<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <div class="card m-b-30">
          <div class="card-header">
            <h5 class="m-b-0">
              <i class="mdi mdi-checkbox-intermediate"></i> {{ $t('pos.button.all') }}
            </h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <data-tables :data="poses"
                           :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }" center-align>
                <el-table-column label="S/N" type="index" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('pos.table.title.name')" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="store.name" :label="$t('pos.table.title.store')">
                  <template #default="scope">
                    <el-select :value="scope.row.store_id" size="mini"
                               @change="updateStore($event, scope.row.id)">
                      <el-option v-can.disable="'pos.store'" v-for="store in stores" :key="store.id"
                                 :label="store.name" :value="store.id"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('pos.table.title.status')">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.active ? 'success' : 'danger'" effect="dark" size="mini">
                      {{ scope.row.active ? $t('label.active') : $t('label.inactive') }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="user.name" :label="$t('label.creator')" ></el-table-column>
                <el-table-column prop="created_at" :formatter="$shortDate" :label="$t('label.created_at')"
                                 sortable></el-table-column>
                <el-table-column label="Actions" min-width="100px">
                  <template v-slot:default="scope">
                    <el-dropdown v-can.event="'pos.update'" @click="showEditDialog(scope.row.id)" split-button type="primary" size="small" trigger="click">
                      <i class="el-icon-edit"></i> {{ $t('button.edit') }}
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-can.disable="'pos.change-status'" @click.native="posChangeStatus(scope.$index, scope.row)">
                          <i class="mdi mdi-archive"></i> {{ $t('pos.button.change_status') }}
                        </el-dropdown-item>
                        <el-dropdown-item v-can.disable="'pos.delete'" @click.native="posDelete(scope.$index, scope.row.id)">
                          <i class="mdi mdi-delete"></i> {{ $t('button.delete') }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-pos :display="displayEditDialog" @close="closeEditDialog" @updated="posUpdate"
                   @created="newPOS" :pos="pos"></edit-pos>
  </div>
</template>

<script>
import CreateEditPOS from './Modal/CreateEditPOS.vue'

export default {
  name: 'Index',
  components: {
    'edit-pos': CreateEditPOS
  },
  data () {
    return {
      loading: false,
      poses: [],
      stores: [],
      pos: {},
      displayEditDialog: false
    }
  },
  methods: {
    updateStore (storeId, posId) {
      this.$posService.changeStore(posId, storeId)
        .then(res => {
          this.notify(this.$t('pos.message.store'))
          this.poses.find(pos => pos.id === posId).store_id = storeId
        })
        .catch(this.globalErrHandle)
    },
    showEditDialog (id) {
      this.pos = this.poses.find(d => d.id === id)
      this.displayEditDialog = true
    },
    closeEditDialog () {
      this.displayEditDialog = false
    },
    newPOS (data) {
      this.poses.splice(0, 0, data)
    },
    posUpdate (data) {
      this.poses.splice(this.poses.indexOf(this.poses.find(d => d.id === data.id)), 1, data)
    },
    posChangeStatus (index, pos) {
      this.askQuestion(this.$t('pos.confirm.status_change'), async () => {
        this.loading = true
        await this.$posService.changePOSStatus(pos.id)
          .then(data => {
            this.posUpdate(data)
            this.loading = false
            this.notify(this.$t('pos.message.status_changed'), this.$t('status.success'))
          })
      })
    },
    posDelete (index, id) {
      this.askQuestion(this.$t('pos.confirm.delete'), async () => {
        this.loading = true
        await this.$posService.deletePOS(id)
          .then(data => {
            this.poses.splice(index, 1)
            this.loading = false
            this.notify(this.$t('pos.message.deleted'), this.$t('status.success'))
          })
      })
    },
    showUsersDialog (id) {}
  },
  async mounted () {
    this.$emit('parent-title', this.$t('pos.title.pos'))
    try {
      await this.withLoading(async () => {
        this.poses = (await this.$posService.getPOSes())
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getPOS:', error)
    }
    await this.$departmentService.getDepartments()
      .then(data => (this.stores = data))
  },
  created () {
    this.$parent.$on('new-pos', this.newPOS)
  }
}
</script>

<style scoped>

</style>
